import { ArrowUpRight } from "lucide-react";

interface AttentionItem {
  id: string;
  title: string;
  provider: string;
  severity: "critical" | "warning" | "info";
}

const severityLabels = { critical: "紧急", warning: "提醒", info: "信息" } as const;

export function DragDownList({ items }: { items: readonly AttentionItem[] }) {
  return (
    <ol className="overview-attention-list">
      {items.map((item, index) => (
        <li key={item.id}>
          <span className="overview-attention-list__index" data-critical={item.severity === "critical" || undefined}>{index + 1}</span>
          <div><strong>{item.title}</strong><p><span data-severity={item.severity}>{severityLabels[item.severity]}</span>{item.provider}</p></div>
          <ArrowUpRight size={14} aria-hidden="true" />
        </li>
      ))}
    </ol>
  );
}
